import { If, Switch, location, reactive, lazy } from 'cdui-js';
import { Header } from './Header';
// import { TarBar } from './TarBar';
import { NotFound } from '../NotFound';
// import { MyPage } from './my';
// import { SelfSelected } from './self-selected';
// import { Market } from './market'; //市场页
// import { DetailStockIndex } from './market/detail-stock-index/index.tsx'; //股票指数详情页
// import { Account } from './account';

import './common.css';
import { Suspense } from 'solid-js';
import { userState, isAppUser } from '../../stores/user';
/** 开户/加开户等静态并入 App 主图（直接引源模块，避免 open-flow 桶造成 chunk 环） */
import { OpenProcess } from './account/open-progress';
import AccountResultPage from './account/result';
import AddAccount from './account/add-account';
import OpenAccountDocs from './account/open-progress/OpenAccountDocs';
import AgreementDocPage from './agreement-doc';
import { LegalDocumentPage } from '../legal/LegalDocumentPage';
import { HelpCenterPage } from './help-center';
import { W8Ben } from './my/components/w8ben/index';
import W8BenResult from './my/components/w8ben/w8ben-result';
import MyPage from './my';
import { ForgetPwd } from './my/components/forget-pwd';
import FundRecords from './fund/fund-records';
import { WithdrawPage } from './deposit/h5-withdraw';
import {
  DepositHome,
  DepositBankStep1,
  DepositBankStep2,
  DepositChequeStep0,
  DepositChequeStep1,
  DepositChequeStep2,
} from './deposit/h5-deposit';
import { CurrencyExchange } from './currency-exchange';
import { StockTransferInHome } from './stock-transfer-in';
import { StockTransferInRecords } from './stock-transfer-in/records';
import { StockTransferInBroker } from './stock-transfer-in/broker';
import { StockTransferInSelectBroker } from './stock-transfer-in/select-broker';
import { StockTransferInOtherBroker } from './stock-transfer-in/other-broker';
import { StockTransferInStocks } from './stock-transfer-in/stocks';
import { StockTransferInStockAdd } from './stock-transfer-in/stock-add';
import { StockTransferInConfirm } from './stock-transfer-in/confirm';
import { StockTransferInSignature } from './stock-transfer-in/signature';
import { StockTransferInSubmitted } from './stock-transfer-in/submitted';
import { CrsFormPage } from './crs';
import { CrsSubmittedPage } from './crs/submitted';
import {
  BankAccountAdd,
  BankAccountDetail,
  BankAccountList,
  BankAccountPendingList,
  BankAccountSuccess,
} from './bank-list';
import { DepositRecordDetail, DepositRecordList } from './deposit-records';
import { recordDetailOf } from './deposit-records/shared';
import { TradeProductsPage, TradeProductsSuccess } from './trade-products';

/** 登录独立 chunk：未登录弹层仍按需拉登录 */
const Login = lazy(() =>
  import('./login').then((m) => ({ default: m.Login })),
);

/** 非开户链路仍 lazy */
const AboutUs = lazy(() =>
  import('./my/components/about-us').then((m) => ({ default: m.AboutUs })),
);
const APPDownLoad = lazy(() => import('./app-download/APPDownLoad.tsx'));
const DebugPage = lazy(() =>
  import('./debug').then((m) => ({ default: m.DebugPage })),
);
const AIChat = lazy(() =>
  import('../all/ai-chat/index.tsx').then((m) => ({ default: m.AIChat })),
);

const VITE_PLATFORM = import.meta.env.VITE_PLATFORM;

/** 未登录也可直接访问（不强制弹出登录层） */
const PUBLIC_PATHS = [
  '/app-download',
  '/debug',
  '/help-center',
  '/about-us',
  '/legal/register',
  '/legal/privacy',
  '/legal/disclaimer',
  '/forget-pwd',
];

const isPublicPath = () => PUBLIC_PATHS.includes(location.path);

/**
 * 路由集合
 */
const routes = [
  {
    path: '/',
    component: () => <div></div>,
  },
  // 开户
  { path: '/open-progress', component: OpenProcess },
  { path: '/account', component: () => <div></div> },
  {
    id: 'my',
    path: '/my',
    component: MyPage,
  },
  {
    id: 'about-us',
    path: '/about-us',
    component: AboutUs, //我的-关于我们
  },
  { path: '/legal/register', component: LegalDocumentPage },
  { path: '/legal/privacy', component: LegalDocumentPage },
  { path: '/legal/disclaimer', component: LegalDocumentPage },
  {
    path: '/agreement-doc',
    component: AgreementDocPage,
  },
  {
    path: '/open-account-docs',
    component: OpenAccountDocs,
  },

  { path: '/w8ben', component: W8Ben },
  { path: '/w8ben-result', component: W8BenResult },
  { id: 'add-account', path: '/add-account', component: AddAccount },
  { path: '/account-result', component: AccountResultPage },
  {
    id: 'add-virtual-applyinfo',
    path: '/add-virtual-applyinfo',
    component: AddAccount,
  },
  { path: '/app-download', component: APPDownLoad },
  { path: '/debug', component: DebugPage },
  { path: '/ai-chat', component: AIChat },
  { path: '/help-center', component: HelpCenterPage },
  { path: '/forget-pwd', component: ForgetPwd },
  { path: '/h5/deposits', component: DepositHome },
  { path: '/deposits', component: DepositHome },
  { path: '/h5/withdrawals', component: WithdrawPage },
  { path: '/withdrawals', component: WithdrawPage },
  { path: '/h5/deposits/bank/step1', component: DepositBankStep1 },
  { path: '/deposits/bank/step1', component: DepositBankStep1 },
  { path: '/h5/deposits/bank/step2', component: DepositBankStep2 },
  { path: '/deposits/bank/step2', component: DepositBankStep2 },
  { path: '/h5/deposits/cheque/step0', component: DepositChequeStep0 },
  { path: '/deposits/cheque/step0', component: DepositChequeStep0 },
  { path: '/h5/deposits/cheque/step1', component: DepositChequeStep1 },
  { path: '/deposits/cheque/step1', component: DepositChequeStep1 },
  { path: '/h5/deposits/cheque/step2', component: DepositChequeStep2 },
  { path: '/deposits/cheque/step2', component: DepositChequeStep2 },
  { path: '/fund-records', component: FundRecords },
  { path: '/h5/fund-records', component: DepositRecordList },
  { path: '/h5/exchange', component: CurrencyExchange },
  { path: '/exchange', component: CurrencyExchange },
  { path: '/h5/stock-transfer-in', component: StockTransferInHome },
  { path: '/stock-transfer-in', component: StockTransferInHome },
  { path: '/h5/stock-transfer-in/records', component: StockTransferInRecords },
  { path: '/stock-transfer-in/records', component: StockTransferInRecords },
  { path: '/h5/stock-transfer-in/select-broker', component: StockTransferInSelectBroker },
  { path: '/stock-transfer-in/select-broker', component: StockTransferInSelectBroker },
  { path: '/h5/stock-transfer-in/other-broker', component: StockTransferInOtherBroker },
  { path: '/stock-transfer-in/other-broker', component: StockTransferInOtherBroker },
  { path: '/h5/stock-transfer-in/broker', component: StockTransferInBroker },
  { path: '/stock-transfer-in/broker', component: StockTransferInBroker },
  { path: '/h5/stock-transfer-in/stocks', component: StockTransferInStocks },
  { path: '/stock-transfer-in/stocks', component: StockTransferInStocks },
  { path: '/h5/stock-transfer-in/stocks/add', component: StockTransferInStockAdd },
  { path: '/stock-transfer-in/stocks/add', component: StockTransferInStockAdd },
  { path: '/h5/stock-transfer-in/confirm', component: StockTransferInConfirm },
  { path: '/stock-transfer-in/confirm', component: StockTransferInConfirm },
  { path: '/h5/stock-transfer-in/signature', component: StockTransferInSignature },
  { path: '/stock-transfer-in/signature', component: StockTransferInSignature },
  { path: '/h5/stock-transfer-in/submitted', component: StockTransferInSubmitted },
  { path: '/stock-transfer-in/submitted', component: StockTransferInSubmitted },
  { path: '/h5/crs', component: CrsFormPage },
  { path: '/crs', component: CrsFormPage },
  { path: '/h5/crs/submitted', component: CrsSubmittedPage },
  { path: '/crs/submitted', component: CrsSubmittedPage },
  { path: '/exchange-currency', component: CurrencyExchange },
  { path: '/bank-list', component: BankAccountList },
  { path: '/h5/bank-accounts', component: BankAccountList },
  { path: '/bank-list/detail', component: BankAccountDetail },
  { path: '/h5/bank-accounts/detail', component: BankAccountDetail },
  { path: '/bank-list/add', component: BankAccountAdd },
  { path: '/h5/bank-accounts/add', component: BankAccountAdd },
  { path: '/bank-list/add-success', component: BankAccountSuccess },
  { path: '/h5/bank-accounts/add-success', component: BankAccountSuccess },
  { path: '/bank-list/pending-list', component: BankAccountPendingList },
  { path: '/h5/bank-accounts/pending-list', component: BankAccountPendingList },
  /** 激活交易品种（App 可嵌套 /h5/trade-products?preselect=&hideNav=1） */
  { path: '/trade-products', component: TradeProductsPage },
  { path: '/h5/trade-products', component: TradeProductsPage },
  { path: '/trade-products/success', component: TradeProductsSuccess },
  { path: '/h5/trade-products/success', component: TradeProductsSuccess },

  // { path: '/face-verify', component: FaceVerify },
  // { path: '/re-face-verify', component: FaceVerify },

  // { path: '/', component: SelfSelected },
  // id: 'market',
  // { path: '/market', component: Market },
  // id: 'information',
  // {
  //   path: '/information',
  //   component: lazy(() => import('./information')),
  // },
  // id: 'finance',
  // { path: '/finance', component: Finance },
  // id: 'account',
  // { path: '/detail-stock-index', component: DetailStockIndex },
  // { path: '/info-detail', component: InfoDetail },
  // {
  //   id: 'message',
  //   path: '/message',
  //   component: Message, //消息
  // },
  // {
  //   id: 'message-detail',
  //   path: '/message-detail',
  //   component: MessageDetail, //消息详情
  // },
  // {
  //   id: 'feedback',
  //   path: '/feedback',
  //   component: Feedback, //反馈
  // },
  // { path: '/settings', component: Settings },

  // { path: '/stocks-details', component: StockDetails },
  // {
  //   path: '/stock-finance-detail',
  //   component: lazy(() => import('../mobile/stock/stock-details/stock-finance-detail/index.tsx')),
  // },
  // { path: '/trade', component: TradeOrder },
  // { path: '/news-detail', component: NewsDetail },
  // { path: '/information-finance', component: StockFinance },
  // { path: '/stock-list', component: StockList }, //股票列表
  // { path: '/debug-info', component: DebugInfo },
  // { path: '/switch-account', component: SwitchAccount },
  // { path: '/user-info', component: UserInfo },
  // { path: '/account-security', component: AccountSafe },
  // { path: '/trade-settings', component: TradeSettings },
  // { path: '/login-device', component: LoginDevice },
  // { path: '/login-device-details', component: LoginDeviceDetails },
  // { path: '/trade-lock-settings', component: TradeLockSettings },
  // { path: '/update-pwd', component: UpdatePwd },
  // { path: '/update-trade-pwd', component: UpdateTradePwd },
  // { path: '/add-search', component: AddSearchPage },
  // { path: '/edit-self', component: EditSelfPage },
  // { path: '/award', component: Award },
  // { path: '/risk-result', component: RiskResult },
  // { path: '/risk-assessment', component: RiskAssessment },
  // { path: '/risk-questionnaire', component: RiskQuestionnaire },
  // { path: '/ipo', component: IPO },

  // { path: '/market-condition', component: MarketCondition },
  // { path: '/buy-ipo', component: BuyIpo },
  // { path: '/ipo-records', component: IpoRecords },
  // { path: '/ipo-details', component: SubscribingDetails },
  // { path: '/buy-ipo-details', component: IpoBuyDetails },
  // { path: '/deposits', component: Deposits },
  // { path: '/fund-records', component: FundRecords },
  // { path: '/more-service', component: MoreService },
  // { path: '/exchange-currency', component: ExchangeCurrency },

  // { path: '/self-info', component: lazy(() => import('../mobile/my/components/self-info')) },
  // { path: '/fund-flow', component: lazy(() => import('../mobile/my/components/fund-flow')) },
  // { path: '/add-bank', component: lazy(() => import('./account/bank/AddBank.tsx')) },
  // { path: '/bank-list', component: lazy(() => import('./account/bank/BankList.tsx')) },
];

/**
 * 切换分支
 */
const switchCase = () => {
  let path = location.path;

  // 主页
  if (path === '/' || path === '/index.html') {
    return routes[0];
  }

  if (recordDetailOf()) {
    return { component: DepositRecordDetail };
  }

  return (
    routes.find((item: any) => item.path === path) || {
      id: '404',
      component: NotFound,
    }
  );
};

// 移动端页面，路由等配置
export const MobileHost = () => {
  
  const state = reactive({
    loading: true,
  });

  // 主导航栏 tabbar配置
  const showTabbar = () => {
    return (
      location.path === '/' || ['/market', '/information', '/account', '/my', '/finance'].includes(location.paths[0])
    );
  };

  // 公共头部显示控制
  const showCommonHeader = () => {
    const routes = ['/', '/market', '/information'];
    return routes.includes(location.paths[0]);
  };

  const rootClassName = VITE_PLATFORM === 'web' ? 'web-platform' : 'app-platform';

  if (localStorage.getItem('token')) {
    userState.isLogin = true;
  }

  let forceActivityLogin = false;
  try {
    forceActivityLogin = new URLSearchParams(window.location.search).get('activityLogin') === '1';
  } catch {
    /* ignore */
  }

  // APP：靠原生下发 token，不弹 H5 登录页
  if (isAppUser()) {
    userState.showLoginPage = false;
  } else if (!userState.isLogin && (forceActivityLogin || !isPublicPath())) {
    // 普通 H5：非公开页未登录弹登录；活动回跳 `?activityLogin=1` 同样强制弹登录
    userState.showLoginPage = true;
  } else if (forceActivityLogin && userState.isLogin) {
    // 已有主站登录态：直接回活动详情
    void import('../../activity/shared/activityLoginReturn').then(({ takeActivityReturnUrl }) => {
      const returnUrl = takeActivityReturnUrl();
      if (returnUrl) window.location.replace(returnUrl);
    });
  }

  return (
    <div class={`${rootClassName}`}>
      {/* <div class="user-login-bg absolute top-0 left-0 right-0 height-160px"></div> */}
      {/* {showCommonHeader() && <Header></Header>} */}

      <main
        id="main"
        class="font-s-S relative"
        // style={{ 'padding-bottom': showTabbar() && VITE_PLATFORM === 'web' ? '54px' : '' }}
      >
        <div class="container">
          <Switch case={switchCase()}></Switch>
        </div>
      </main>

      {/* <If when={showTabbar()}>
        <TarBar></TarBar>
      </If> */}

      {/* 公开页即使 showLoginPage 为 true 也不盖登录层 */}
      <If when={userState.showLoginPage && !isPublicPath()}>
        <Suspense fallback={null}>
          <Login />
        </Suspense>
      </If>
    </div>
  );
};
